import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CmsConfig, provideDefaultConfig} from '@spartacus/core';
import {CustomDcpConfiguratorSinglePageFormComponent} from './custom-dcp-configurator-single-page-form.component';
import {
  ConfigureServiceErrorModule
} from '@app/product/configurator/error-handling/configure-service-error/configure-service-error.module';
import {DcpConfiguratorSinglePageFormModule} from '@dcp/configurator';

@NgModule({
  imports: [
    DcpConfiguratorSinglePageFormModule,
    ConfigureServiceErrorModule,
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        ConfiguratorForm: {
          component: CustomDcpConfiguratorSinglePageFormComponent,
        },
      },
    } as CmsConfig),
  ],
  declarations: [
    CustomDcpConfiguratorSinglePageFormComponent,
  ],
  exports: [CustomDcpConfiguratorSinglePageFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CustomDcpConfiguratorSinglePageFormModule {
}
